<template>
  <div id="app">
    <div v-if="loading">
      Loading...
    </div>
    <template v-else>
      <div class="control-bar">
        <EventType/>
        <EventLocation/>
        <DateRange/>
      </div>
      <EventResults/>
    </template>
  </div>
</template>

<script>
import DateRange from './DateRange.vue'
import { mapActions, mapMutations } from 'vuex'
import EventType from './EventType.vue'
import EventLocation from './EventLocation.vue'
import EventResults from './EventResults.vue'

export default {
  name: 'events-viewer',
  components: { EventResults, EventLocation, EventType, DateRange },
  data: function () {
    return {
      loading: true
    }
  },
  async mounted () {
    this.SET_DEFAULTS(window.eventsViewer)
    await this.retrieveEvents()
    this.loading = false
  },
  methods: {
    ...mapActions(['retrieveEvents']),
    ...mapMutations(['SET_DEFAULTS'])
  }
}
</script>
